export enum RegistrationRoutes {
  SIGN_IN = '/signin',
  SIGN_IN_SOCIAL = '/signin-social',
  SIGN_UP = '/signup',
  DROP_PASSWORD = '/drop-password',
  RESET_PASSWORD = '/restore-password'
}